import { create } from 'zustand';
import { getAppInfoSettings } from '@/services/settings';
import { updatePWAManifest, savePwaInstallMeta } from '@/utils/pwa';

/**
 * App Settings Store
 * Manages global application settings like logo, name, contact info
 */
const useAppSettingsStore = create((set) => ({
  settings: {
    app_name: '',
    app_logo: '',
    phone_number_1: '',
    phone_number_2: '',
    app_url: '',
    whatsapp_number: '',
    instagram_id: '',
    telegram_number: '',
    address: '',
    customer_price_display_mode: 'Rotating',
  },
  loading: false,
  error: null,

  /**
   * Fetch app settings from the API (public endpoint - no auth required)
   */
  fetchSettings: async () => {
    set({ loading: true, error: null });
    try {
      const data = await getAppInfoSettings();
      const newSettings = {
        app_name: data?.app_name || '',
        app_logo: data?.app_logo || '',
        phone_number_1: data?.phone_number_1 || '',
        phone_number_2: data?.phone_number_2 || '',
        app_url: data?.app_url || '',
        whatsapp_number: data?.whatsapp_number || '',
        instagram_id: data?.instagram_id || '',
        telegram_number: data?.telegram_number || '',
        address: data?.address || '',
        rejectTime: data?.rejectTime || 0,
        customer_price_display_mode:
          data?.customer_price_display_mode === 'Stable' ? 'Stable' : 'Rotating',
      };
      set({ 
        settings: newSettings,
        loading: false 
      });
      savePwaInstallMeta(newSettings);
      void updatePWAManifest(newSettings);
    } catch (error) {
      console.error('Error fetching app settings:', error);
      set({ 
        error: error.message || 'Failed to fetch settings',
        loading: false 
      });
    }
  },

  /**
   * Update settings in the store (after save)
   */
  updateSettings: (newSettings) => {
    set((state) => {
      const updatedSettings = { ...state.settings, ...newSettings };
      savePwaInstallMeta(updatedSettings);
      void updatePWAManifest(updatedSettings);
      return { settings: updatedSettings };
    });
  },

  /**
   * Clear settings
   */
  clearSettings: () => {
    set({
      settings: {
        app_name: '',
        app_logo: '',
        phone_number_1: '',
        phone_number_2: '',
        app_url: '',
        whatsapp_number: '',
        instagram_id: '',
        telegram_number: '',
        address: '',
        customer_price_display_mode: 'Rotating',
      }
    });
  },
}));

export default useAppSettingsStore;

